import { ChooseLuckyCardScreenDataDto } from "../types/ChooseLuckyCardScreenData";
import { QuestionStatistics } from "../types/QuestionStatistics";
import { client } from "./axios";

export const luckyCardApi = {

    getLuckyCard: async (): Promise<ChooseLuckyCardScreenDataDto> => {
        const response = await client.post<ChooseLuckyCardScreenDataDto>(`/requestLuckyCardDeck`);
        console.log("response", response.data);
        return response.data;
    },

    chooseCard: async (index: number): Promise<void> => {
        const response = await client.post<void>(`/selectLuckyCard/?index=${index}`);
        return response.data;
    },

    getStatistics: async (): Promise<QuestionStatistics> => {
        const response = await client.get<QuestionStatistics>(`/getGlobalStatistics`);
        return response.data;
    }
}
